import { render, staticRenderFns } from "./spareTypeSlelector.vue?vue&type=template&id=37009dcf"
import script from "./spareTypeSlelector.vue?vue&type=script&lang=js"
export * from "./spareTypeSlelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports